import React, { Component } from "react";
import { compose, graphql } from "react-apollo";

import CollaboratorForm from "./CollaboratorForm";
import Queries from "../../queries/queries2";
import Spinner from "../../elements/Spinner/Spinner";

import { getTiersXtraData, setTiersXtraData } from "../../tools/tiersExtraData";


class CollaboratorEdit extends Component {
  constructor(props) {
    super(props);
    // console.log('CollaboratorEdit constructor', props);

    console.log('13 - Props=', props);

    if (props.getCollaboratorQuery.tiers && props.getTiersCollaboratorMailNotifQuery.getTiersCollaboratorMailNotif) {
      this.state = this.getStateObject({
        tiers: props.getCollaboratorQuery.tiers,
        notifs: props.getTiersCollaboratorMailNotifQuery.getTiersCollaboratorMailNotif
      });
    } else {
      this.state = { collaborator: null };
    }

    props.getCollaboratorQuery.refetch();
  }
  getStateObject({
    tiers,
    notifs,
    xtraData
    // id,
    // firstname,
    // lastname,
    // email,
    // iban,
    // swift,
    // currency,
    // collaborator,
    // company,
    // notifBankTransactions,
    // notifBankAlerts
  }) {

    // console.log("40 - tiers=", tiers);
    // console.log("41 - notifs=", notifs);
    return {
      collaborator: {
        id: tiers.id,
        firstName: tiers.firstname,
        lastName: tiers.lastname,
        email: tiers.email,
        iban: tiers.iban,
        swift: tiers.swift,

        taxableValue: tiers.xtraData ? getTiersXtraData(tiers.xtraData).taxable : null,
        externalCodeValue: tiers.xtraData ? getTiersXtraData(tiers.xtraData).externalCode : null,
        escomptePercentValue: tiers.xtraData ? getTiersXtraData(tiers.xtraData).escomptePercent : null,

        currency: tiers.currency ? tiers.currency.id : tiers.company.currency.id,
        fixPhone: tiers.collaborator.telFixe,
        mobilePhone: tiers.collaborator.telMobile,
        role: tiers.collaborator.role,
        invite: tiers.collaborator.invite,
        tax1: tiers.collaborator.defaultTax1,
        tax2: tiers.collaborator.defaultTax2,
        taxIdemCompany: tiers.collaborator.taxIdemCompany,
        notifBankTransactions: notifs.notifBankTransactions,
        notifBankAlerts: notifs.notifBankAlerts
      }
    };
  }

  componentDidUpdate(prevProps) {
    // console.log('CollaboratorEdit componentDidUpdate', this.props);
    if (
      this.props.getTiersCollaboratorMailNotifQuery.getTiersCollaboratorMailNotif &&
      this.props.getCollaboratorQuery.tiers &&
      prevProps.getCollaboratorQuery.tiers !==
      this.props.getCollaboratorQuery.tiers
    ) {
      console.log("68 - this.props.getTiersCollaboratorMailNotifQuery.getTiersCollaboratorMailNotif=", this.props.getTiersCollaboratorMailNotifQuery.getTiersCollaboratorMailNotif);
      this.setState(this.getStateObject({
        tiers: this.props.getCollaboratorQuery.tiers,
        notifs: this.props.getTiersCollaboratorMailNotifQuery.getTiersCollaboratorMailNotif
      }));
    }
    else {
      if (
        this.props.getCollaboratorQuery.tiers &&
        this.props.getTiersCollaboratorMailNotifQuery.getTiersCollaboratorMailNotif &&
        prevProps.getTiersCollaboratorMailNotifQuery.getTiersCollaboratorMailNotif !==
        this.props.getTiersCollaboratorMailNotifQuery.getTiersCollaboratorMailNotif
      ) {
        console.log("77 - this.props.getTiersCollaboratorMailNotifQuery.getTiersCollaboratorMailNotif=", this.props.getTiersCollaboratorMailNotifQuery.getTiersCollaboratorMailNotif);
        this.setState(this.getStateObject({
          tiers: this.props.getCollaboratorQuery.tiers,
          notifs: this.props.getTiersCollaboratorMailNotifQuery.getTiersCollaboratorMailNotif
        }));
      }
    }
  }
  onSubmit = values => {
    if (values && values.name === "")
      return;

    values[
      "collaboratorId"
    ] = this.props.getCollaboratorQuery.tiers.collaborator.id;

    values["disconnectTax1"] = !!(!values.tax1 && this.state.collaborator.tax1);
    values["connectTax1"] = !!(
      values.tax1 && values.tax1 !== this.state.collaborator.tax1
    );
    values["disconnectTax2"] = !!(!values.tax2 && this.state.collaborator.tax2);
    values["connectTax2"] = !!(
      values.tax2 && values.tax2 !== this.state.collaborator.tax2
    );
    if (
      !this.state.collaborator.taxIdem &&
      values.taxIdemCompany &&
      !!this.state.collaborator.tax1 &&
      !!this.state.collaborator.tax2
    ) {
      values["disconnectTax1"] = true;
      values["disconnectTax2"] = true;
    }
    if (values.taxIdemCompany) {
      values["connectTax1"] = !!values.tax1;
      values["connectTax2"] = !!values.tax2;
    }

    // xtraData
    values["xtraData"] = setTiersXtraData(this.props.xtraData, values.taxableValue, values.externalCodeValue, values.escomptePercentValue)

    this.props.onSubmit(values);
  };

  deleteCollaborator = async () => {
    console.log(">> onDelete...", this.props.getCollaboratorQuery.tiers);

    const deleted = await this.props.deleteTiers_Collaborator({
      variables: this.props.getCollaboratorQuery.tiers
    });

    return deleted;
  };



  render() {
    // console.log("87 - CollaboratorEdit render", this.props);
    // console.log("88 - CollaboratorEdit render", this.state);
    if (this.state.collaborator && this.props.getTiersCollaboratorMailNotifQuery.loading === false) {

      const companyId =
        this.props.getCollaboratorQuery.tiers &&
        this.props.getCollaboratorQuery.tiers.company.id;

      return (
        <CollaboratorForm
          companyId={companyId}
          sendNotification={this.props.sendNotification}
          cancel={this.props.cancel}
          inSideModal={this.props.inSideModal}
          comptableOnly={this.props.comptableOnly}
          companyDefaultInfos={this.props.companyDefaultInfos}
          odooMenu={this.props.odooMenu}
          collaborator={this.state.collaborator}
          onSubmit={values => this.onSubmit(values)}
          deleteCollaborator={this.deleteCollaborator}
          role={this.props.role}
          handleMinimizeSidebar={this.props.handleMinimizeSidebar}
          notifBankTransactions={this.state.collaborator.notifBankTransactions}
          notifBankAlerts={this.state.collaborator.notifBankAlerts}
        />
      );
    }
    return <Spinner size="lg" fullScreen />;
  }
}

export default compose(
  graphql(Queries.GET_COLLABORATOR, { name: "getCollaboratorQuery" }),
  graphql(Queries.DELETE_TIERS_MUTATION, { name: "deleteTiers_Collaborator" }),
  graphql(Queries.GET_TIERS_COLLABORATOR_MAIL_NOTIF, { name: "getTiersCollaboratorMailNotifQuery" })
)(CollaboratorEdit);
